package com.exura.features.publicplans.domain.api

import kotlinx.serialization.Serializable
import kotlin.js.JsName

@Serializable
@JsName("RefreshPlanStatisticsResponse")
data class RefreshPlanStatisticsResponse(
    @JsName("success")
    val success: Boolean,

    @JsName("message")
    val message: String? = null
)